import { orderBy } from 'lodash';

import { COMMENTABLE_TYPES } from '../constants';

export const orderCommentsByAsc = (comments) =>
  orderBy(comments, ['created_at'], 'asc');

export const orderCommentsByDesc = (comments, sortBy) => {
  if (sortBy === 'votes') {
    return orderBy(comments, ['votes.score'], ['desc']);
  }

  // Sort by recents
  return orderBy(comments, ['created_at'], 'desc');
};

export const getFirstCommentsDesc = (comments, sortBy, maxComments) =>
  orderCommentsByDesc(comments, sortBy)?.slice(0, maxComments);

export const addComment = ({ comment, comments }) => [...comments, comment];

export const deleteComment = ({ id, comments }) =>
  comments.filter((element) => element.id !== id);

export const editComment = ({ comment, comments }) => {
  const { id } = comment;

  return comments.map((obj) => (obj.id === id ? comment : obj));
};

export const isReply = (commentableType) =>
  commentableType === COMMENTABLE_TYPES.COMMENT;

export const makeCommentLink = ({ comment, parentUrl }) => {
  let urlString = parentUrl;

  if (parentUrl.startsWith('/')) {
    const { origin } = window.location;

    urlString = origin + parentUrl;
  }

  const url = new URL(urlString);

  const {
    commentable_id: commentableId,
    commentable_type: commentableType,
    id,
  } = comment;

  if (isReply(commentableType)) {
    url.searchParams.set('comment_id', commentableId);
    url.searchParams.set('reply_id', id);

    return url.toString();
  }

  url.searchParams.set('comment_id', id);

  return url.toString();
};
